import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../icons/logo';
import { ItComponent } from '../icons/it';
import { EnComponent } from '../icons/en';
import { LocaleService } from '../../services/locale';

@Component({
  selector: 'app-paused',
  imports: [CommonModule, LogoComponent, ItComponent, EnComponent],
  template: `
    <div class="flex min-h-screen flex-col lg:flex-row">
      <div class="w-full lg:w-1/2 min-h-screen px-4 py-6 sm:px-8 sm:py-8 md:px-12 md:py-10 lg:px-16 lg:py-12 flex flex-col gap-6 bg-white">
        <div class="flex justify-between items-center">
          <app-logo></app-logo>
          <div
            (click)="switchLanguage()"
            class="p-2 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
          >
            <app-it *ngIf="language === 'italian'"></app-it>
            <app-en *ngIf="language === 'english'"></app-en>
          </div>
        </div>
        <div class="flex-1 flex flex-col justify-center max-w-md mx-auto w-full lg:max-w-lg lg:mx-0">
          <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold futura leading-tight text-[#043B22]">
            {{ locale.paused.heading }}
          </h1>
          <div class="mt-5 h-[3px] w-14 bg-[#76AA84]"></div>
          <p class="mt-5 text-[14px] sm:text-[15px] leading-relaxed text-[#616161]">
            {{ locale.paused.body }}
          </p>
          <p class="mt-3 text-[14px] sm:text-[15px] leading-relaxed text-[#616161]">
            {{ locale.paused.thanks }}
          </p>
        </div>
      </div>
      <div class="hidden lg:block lg:w-1/2 h-screen sticky top-0">
        <img src="images/welcome.png" class="object-cover h-full w-full" alt="" />
      </div>
    </div>
  `
})
export class PausedComponent {
  localeService = inject(LocaleService);
  locale = this.localeService.locale();
  language = this.localeService.getLanguage();

  switchLanguage() {
    this.localeService.switchLocale();
    window.location.reload();
  }
}
